module.exports = __webpack_public_path__ + "img/Aicad_digital.8829e52b.svg";